let Slider;
export default () => ({
	createSlider(section, space = 10) {
		const slider_el = document.querySelector(`.${section} .featured-product-slider`);
		const slides = slider_el.querySelectorAll('.featured-product');
		if (slides.length > 3 && slides.length < 5) {
			if (window.innerWidth >= 1280) {
				slider_el.parentNode.classList.add('disabled');
			}
			Slider = new window.Swiper(`.${section} .featured-product-slider`, {
				slidesPerView: 1.25,
				speed: 500,
				spaceBetween: space,
				breakpoints: {
					480: {
						slidesPerView: 2,
					},
					768: {
						slidesPerView: 3,
					},
					1280: {
						enabled: false,
						slidesPerView: 'auto',
					},
				},
				navigation: {
					nextEl: `.${section} .next-slide`,
					prevEl: `.${section} .prev-slide`,
				},
				pagination: {
					el: `.${section} .featured-product-pagination`,
					type: 'progressbar',
				},
			});
		} else if (slides.length < 4) {
			if (window.innerWidth >= 768) {
				slider_el.parentNode.classList.add('disabled');
			}
			Slider = new window.Swiper(`.${section} .featured-product-slider`, {
				slidesPerView: 1.25,
				speed: 500,
				spaceBetween: space,
				breakpoints: {
					480: {
						slidesPerView: 2,
					},
					768: {
						slidesPerView: 'auto',
						enabled: false,
					},
				},
				navigation: {
					nextEl: `.${section} .next-slide`,
					prevEl: `.${section} .prev-slide`,
				},
				pagination: {
					el: `.${section} .featured-product-pagination`,
					type: 'progressbar',
				},
			});
		} else if (slides.length == 5) {
			if (window.innerWidth >= 1440) {
				slider_el.parentNode.classList.add('disabled');
			}
			Slider = new window.Swiper(`.${section} .featured-product-slider`, {
				slidesPerView: 1.25,
				speed: 500,
				spaceBetween: space,
				breakpoints: {
					480: {
						slidesPerView: 2,
					},
					768: {
						slidesPerView: 3,
					},
					1024: {
						slidesPerView: 4,
					},
					1440: {
						slidesPerView: 'auto',
						enabled: false,
					},
				},
				navigation: {
					nextEl: `.${section} .next-slide`,
					prevEl: `.${section} .prev-slide`,
				},
				pagination: {
					el: `.${section} .featured-product-pagination`,
					type: 'progressbar',
				},
			});
		} else if (slides.length > 5) {
			Slider = new window.Swiper(`.${section} .featured-product-slider`, {
				slidesPerView: 1.25,
				speed: 500,
				spaceBetween: space,
				breakpoints: {
					480: {
						slidesPerView: 2,
					},
					768: {
						slidesPerView: 3,
					},
					1024: {
						slidesPerView: 4,
					},
					1440: {
						slidesPerView: 5,
					},
				},
				navigation: {
					nextEl: `.${section} .next-slide`,
					prevEl: `.${section} .prev-slide`,
				},
				pagination: {
					el: `.${section} .featured-product-pagination`,
					type: 'progressbar',
				},
			});
		}
	},
});
